import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoColors from '../../../../theme/promoColors';
import promoMedia from '../../../../theme/promoMedia';
import { PromoIcon } from '../PromoIcon/PromoIcon';
import { PromoText } from '../PromoText/PromoText';

const IconWrap = styled.span`
    display: inline-block;
    margin: 0 4px;
    position: relative;
    top: 3px;
    width: 20px;
    height: 20px;

    ${promoMedia.desktop1440} {
        top: 6px;
    }
`;
const Container = styled.div`
    padding: 24px 0;

    a {
        &:hover {
            ${IconWrap} svg {
                --accent: ${promoColors.purple40};
            }
        }
    }
`;

export const Breadcrumbs = (props) => {
    const lastItem = props.breadcrumbsItems.pop();

    return (
        <Container>
            {props.breadcrumbsItems &&
                props.breadcrumbsItems.map((item) => {
                    return (
                        <PromoText key={item.name} tag="link" href={item.url}>
                            {item.name}
                            <IconWrap>
                                <PromoIcon size="16px" name="chevron-right" color="primary" />
                            </IconWrap>
                        </PromoText>
                    );
                })}

            <PromoText color="gray80">{lastItem.name}</PromoText>
        </Container>
    );
};

Breadcrumbs.propTypes = {
    breadcrumbsItems: PropTypes.array,
};
